import { makeObservable, observable, computed, action } from 'mobx';
import { erpApiurl } from '../stores/APIEndpoints';

const PENDING = 'pending';
const DONE = 'done';
const ERROR = 'error';

const EMPTY_MESSAGE = { status: "", help: "" };
const ERROR_MESSAGE = { status: "error", help: "Unable to fetch the Invoices. The Service is unavailable. Please try after sometime." };

export default class InvoiceDetailsStore {

    state = PENDING;
    message = EMPTY_MESSAGE;
    invoices = [];
    rowCount = 0;
    dailyInvoicesCount = 0;
    monthlyInvoicesCount = 0;
    totalAmount = 0;

    constructor(props) {
        this.apiProxy = props.apiProxy;
        this.referrerId = props.referrerId;
        this.collectionType = props.collectionType;

        makeObservable(this, {
            state: observable,
            message: observable,
            invoices: observable,
            rowCount: observable,
            dailyInvoicesCount: observable,
            monthlyInvoicesCount: observable,
            totalAmount: observable,

            isLoading: computed,
            isError: computed,
            isDone: computed,

            fetchInvoices: action,
            // fetchPaymentsByCollection: action,
            generateInvoiceData:action,
        });
    }


    get isLoading() {
        return this.state === PENDING;
    }

    get isError() {
        return this.state === ERROR;
    }

    get isDone() {
        return this.state === DONE;
    }

    fetchInvoices = async () => {
        const invoiceUrl = `${erpApiurl}api/Carbon/GetLabInvioceSummary?ReferrerId=${this.referrerId}&collectionType=${this.collectionType}`

        let invoiceData = await this.fetchByUrl(invoiceUrl);

        this.generateInvoiceData(invoiceData);
    }
   
    /**
     * Send the request to the endpoint using the FetchAPI
     * 
     */
     fetchByUrl = async (url) => {

        this.state = PENDING;
        this.message = EMPTY_MESSAGE;

        try {
            const response = await this.apiProxy.getAsync(url);
            const data = await response.json();

            if (data.Message) {
                this.message = ERROR_MESSAGE;
                this.state = DONE;
                return [];
            }
            this.state = DONE;
            return data;
        }
        catch (e) {
            this.state = ERROR;
            this.message = ERROR_MESSAGE
            console.log(e);
        }
        return [];
    }

    generateInvoiceData = (invoiceData) => {
        const data = [];

        for(let i=0;i<invoiceData.length;i++) {
            const item = invoiceData[i];
            this.totalAmount = this.totalAmount + item.BillTotal;
            item["collectionType"] = this.collectionType;
            data.push(item);
        }

        if(this.collectionType == "daily") {
            this.dailyInvoicesCount = invoiceData.length;
            this.monthlyInvoicesCount = 0;
        }
        else {
            this.dailyInvoicesCount = 0;
            this.monthlyInvoicesCount = invoiceData.length;
        }

        this.invoices = data;
        this.rowCount = data.length;
    }

    /**
     * 
     * @param {*} invoiceHeader 
     */
    showInvoice = async(invoiceHeader) => {

        const url = `${erpApiurl}api/Carbon/GetLabInvoiceListByinvioce?invoiceno=${invoiceHeader.number}`
        const data = await this.fetchByUrl(url);
        const summary = this.buildSummary(data);
        const items = this.buildItems(data);
        const payload = {
            header: invoiceHeader,
            items: items,
            summary: summary
        }

        console.log(payload);
        
        const reportUrl = `https://numedlabs.com/mailer/mailer/invoices/reports/${invoiceHeader.number}`;
        const response = await this.apiProxy.asyncPost(reportUrl,payload);
        const reportId = await response.text();

        if (reportId === invoiceHeader.number) {
            return reportUrl;
        }

        console.log("Error in Creating Report");
        return "Error";
    }

    buildSummary = (data) => {
        const summary = {
            totalAmount: 0,
            totalReceivedAmount: 0,
            totalDue: 0
        };

        data.map((item) => {
            summary.totalReceivedAmount = summary.totalReceivedAmount + item.PaidAmount;
            summary.totalAmount = summary.totalAmount + item.Total;
        })

        summary.totalDue = summary.totalAmount - summary.totalReceivedAmount;

        return summary;
    }

    buildItems = (data) => {
        let items = [];

        data.map((item) => {
            
            const itemData = {
                CreatedOn: item.CreatedOn,
                CustomerName: item.CustomerName,
                SidCode: item.SidCode,
                Total: item.Total,
                ReceivedAmount: item.PaidAmount,
                Due: item.Total - item.PaidAmount,
                TestOrProfileName: item.TestOrProfileName
            }

            items.push(itemData);
        })

        return items;
    }

}
